import script from "./textArea.vue?vue&type=script&setup=true&lang=js"
export * from "./textArea.vue?vue&type=script&setup=true&lang=js"

import "./textArea.vue?vue&type=style&index=0&id=0540ddac&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0540ddac"]])

export default __exports__